import withStyles from 'isomorphic-style-loader/withStyles'
import React from 'react'
import PropTypes from 'prop-types'
import { GearIcon, SignOutIcon, SmileyIcon, BellIcon } from '@primer/octicons-react'
import NavigationMenu from './NavigationMenu'
import s from './NavigationReader.css'

/**
 * Bandeau de droite spécifique aux utilisateurs lecteurs (type >= 40).
 * Affiche : "Bonjour, {label}" + menu déroulant (Mon profil / Mes notifications) + bouton déconnexion direct.
 *
 * @param {Object} props
 * @param {Object} props.me Utilisateur connecté
 * @param {string} props.menuOpened Clé du menu actuellement ouvert
 * @param {Function} props.handleMenu Handler unique pour les clics menus
 * @param {Function} props.getIconTag Helper pour créer une icône
 * @param {Function} props.t Fonction de traduction
 */
const NavigationReader = ({ me, menuOpened, handleMenu, getIconTag, t }) => {
  const userLabel = (me && (me.label || me.login)) || ''

  const accountOptions = [
    { icon: getIconTag(SmileyIcon), label: t('navigation.myprofil'), link: '/profile' },
    { icon: getIconTag(BellIcon), label: t('navigation.mynotification'), link: '/setnotificationuser' }
  ]

  return (
    <div className={s.readerBar}>
      <div className={s.hello}>{t('home.reader.hello', { name: userLabel })}</div>
      <div className={s.menuWrapper}>
        <NavigationMenu
          menuKey="account"
          menuOpened={menuOpened}
          title={{ icon: getIconTag(GearIcon), label: '' }}
          options={accountOptions}
          handleMenu={handleMenu}
        />
      </div>
      <a className={[s.link, s.logout].join(" ")} href="/logout" title={t('navigation.disconnect')}>
        <SignOutIcon size={22} />
      </a>
    </div>
  )
}

NavigationReader.propTypes = {
  me: PropTypes.object,
  menuOpened: PropTypes.string,
  handleMenu: PropTypes.func.isRequired,
  getIconTag: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
}

export default withStyles(s)(NavigationReader)
